import type { ColumnDef } from "@tanstack/react-table";
import type { AdminArticleListItem } from "@/types/article";
import { ArticleTypeBadge } from "./article-type-badge";
import { ArticleStatusBadge } from "./article-status-badge";
import { ArticleActions } from "./article-actions";
import { formatDate } from "@/lib/format";

export type ArticleAction = "edit" | "publish" | "unpublish" | "delete";

export function getArticleColumns(
  onAction: (
    article: AdminArticleListItem,
    action: ArticleAction
  ) => void
): ColumnDef<AdminArticleListItem>[] {
  return [
    {
      accessorKey: "title",
      header: "제목",
      cell: ({ row }) => {
        const title = row.original.title.ko;
        return (
          <div className="font-medium text-sm max-w-[300px] truncate" title={title}>
            {title}
          </div>
        );
      },
    },
    {
      accessorKey: "type",
      header: "유형",
      cell: ({ row }) => <ArticleTypeBadge type={row.original.type} />,
    },
    {
      accessorKey: "publishedAt",
      header: "상태",
      cell: ({ row }) => (
        <ArticleStatusBadge publishedAt={row.original.publishedAt} />
      ),
    },
    {
      accessorKey: "authorInfo.name.ko",
      header: "작성자",
      cell: ({ row }) => (
        <div className="text-sm">{row.original.authorInfo.name.ko}</div>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "생성일",
      cell: ({ row }) => (
        <div className="text-sm whitespace-nowrap">
          {formatDate(row.original.createdAt, { format: "short" })}
        </div>
      ),
    },
    {
      accessorKey: "updatedAt",
      header: "수정일",
      cell: ({ row }) => (
        <div className="text-sm whitespace-nowrap">
          {formatDate(row.original.updatedAt, { format: "short" })}
        </div>
      ),
    },
    {
      id: "actions",
      header: "작업",
      cell: ({ row }) => (
        <ArticleActions article={row.original} onAction={onAction} />
      ),
    },
  ];
}
